import { Subscription } from 'rxjs/Rx'
import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  ElementRef,
  ViewChild,
} from '@angular/core'
import { Router } from '@angular/router'
import { DomUtils, AppContext } from '@mprep/shared/lib/helpers'
import { AuthenticationService } from '@mprep/shared/core/services'
import { User, MenuItem, PathConfiguration, PathNode, } from '@mprep/shared/data/models'

import {
  NavigationService,
  MenuItemFactory,
  PathResetService,
  IntroService,
  MenuService,
  AppStateService,
  WORKSPACE_BASE_URL
} from './../../'

@Component({
  selector: 'mp-sidebar',
  templateUrl: './sidebar.html',
  styleUrls: ['./sidebar.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {

  private static MENU_TOGGLE_BUTTON_ID = 'hamburger'

  private _menuItemSubscription: Subscription

  public currentUser: User
  public sideMenuElements: EventEmitter<any> = new EventEmitter()
  public globalMenuItems: MenuItem[]
  public menuItems: MenuItem[]
  public applicationMenuItems: MenuItem[]
  public isResourceMenuCollapsed: boolean = true
  public toggleMessage: string = 'Expand Menu'

  @ViewChild('sidebarMenu')
  public sidebarMenuElement: ElementRef

  constructor(
    private _appContext: AppContext,
    private _router: Router,
    private _navigationService: NavigationService,
    private _pathResetService: PathResetService,
    private _introService: IntroService,
    private _authenticationService: AuthenticationService,
    private _menuService: MenuService,
    private _menuItemFactory: MenuItemFactory,
    private _appStateService: AppStateService,
    private _domUtils: DomUtils
  ) {}

  public ngOnInit() {
    this._navigationService.onToggleSidebar.subscribe(() => {
      this._toggleMenu()
    })

    this._menuService.getMenu(this._appStateService.pathConfiguration).subscribe((menu) => {
     this._setMenuItems(menu)
    })

    this._menuItemSubscription = this._appStateService.pathConfigurationChanged
      .subscribe((pathConfig: PathConfiguration) => {
        this._menuService.getMenu(pathConfig).subscribe((menu) => {
          this._setMenuItems(menu)
        })
      })

    this.currentUser = this._appContext.currentUser
  }

  public ngOnDestroy() {
    this._menuItemSubscription.unsubscribe()
  }

  public onClickedOutside(clickedElementEvent) {
    this.closeSubMenus()

    const hamburgerElement = this._domUtils
      .findParentBy(clickedElementEvent.targetElement, {id: SidebarComponent.MENU_TOGGLE_BUTTON_ID})

    if (typeof hamburgerElement === 'undefined') {
      this._toggleMenu(true)
    }
  }

  public onMenuItemClick($event) {
    this.closeSubMenus()
    this._toggleMenu(true)
    $event.stopPropagation()
  }

  public getCss(menuItem: MenuItem) {
    return menuItem.styles.join(' ')
  }

  public invokeAction(menuItem: MenuItem) {
    const functionName = `${menuItem.action.value}Action`
    const actionFn = this[functionName]
    if (! actionFn) {
      throw new Error(`Action function '${functionName}' does not exist!`)
    }
    const actionArgs = Array.isArray(menuItem.action.args) ?  menuItem.action.args : []
    return actionFn.call(this, ...actionArgs)
  }

  public closeSubMenus() {
    this.sideMenuElements.emit()
  }

  public resetPathAction(pathRoot: PathNode) {
    this._pathResetService.triggerPathReset(pathRoot)
  }

  public navigateBackToWorkspaceAction() {
    this._navigationService.navigateToLastWorkspaceLocation()
  }

  public tourExperienceAction() {
    this._introService.openIntro.emit()
  }

  public logoutAction() {
    this._authenticationService.logout().subscribe()
  }

  public switchSyllabusAction() {
    this._router.navigate([WORKSPACE_BASE_URL, this._appStateService.pathConfiguration.rootPathNode.id, 'switch'])
  }

  private _toggleMenu(state: boolean = !this.isResourceMenuCollapsed) {
    this.isResourceMenuCollapsed = state
    this._navigationService.setMenuStatus(state)
  }

  private _setMenuItems(menu: MenuItem) {
    const globalsIndex = menu.menuItems.findIndex((menu) => menu.title.toLowerCase() === 'global options')
    const dbGlobalsMenu = globalsIndex < 0 ? new MenuItem() : menu.menuItems.splice(globalsIndex, 1)[0]
    this.globalMenuItems = dbGlobalsMenu.menuItems.concat(this._menuItemFactory.createGlobalMenuItems())
    this.menuItems = menu.menuItems
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/sidebar/sidebar.component.ts